import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Sparkles, Flame } from 'lucide-react';
export function ProblemSection() {
  const painPoints = [{
    icon: <Heart className="w-8 h-8 text-artisanal-terracotta" data-id="element-159" />,
    title: 'Desconexión del estrés',
    desc: 'Encuentra un refugio en el trabajo manual, alejándote de las pantallas y la rutina diaria.'
  }, {
    icon: <Sparkles className="w-8 h-8 text-artisanal-terracotta" data-id="element-160" />,
    title: 'Expresión creativa',
    desc: 'Siente la frustración de no tener un espacio para dejar volar tu imaginación y crear algo hermoso.'
  }, {
    icon: <Flame className="w-8 h-8 text-artisanal-terracotta" data-id="element-161" />,
    title: 'Oportunidad de negocio',
    desc: 'Deseas generar ingresos extra haciendo algo que realmente te apasione y tenga demanda.'
  }];
  return <section className="py-20 bg-artisanal-cream" data-id="element-162">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-163">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-164">
          <h2 className="font-serif text-3xl md:text-4xl text-artisanal-brown font-bold mb-6" data-id="element-165">
            ¿Sientes que necesitas un respiro creativo?
          </h2>
          <p className="font-sans text-lg text-artisanal-brown/80 max-w-3xl mx-auto" data-id="element-166">
            Muchas personas buscan una actividad que no solo les permita
            relajarse, sino también crear productos útiles, naturales y con un
            toque personal. Imagina el orgullo de encender una vela o usar un
            jabón hecho con tus propias manos.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-167">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-artisanal-beige text-center" data-id="element-168">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-artisanal-beige mb-6" data-id="element-169">
                {point.icon}
              </div>
              <h3 className="font-serif text-xl font-bold text-artisanal-brown mb-3" data-id="element-170">
                {point.title}
              </h3>
              <p className="font-sans text-artisanal-brown/70" data-id="element-171">{point.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}